module.exports = __webpack_public_path__ + "static/beauty-d01094f3e230dab9c67f168703a20e67.png";